"use strict";

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BoxSlider = /*#__PURE__*/_createClass(function BoxSlider(container) {
  _classCallCheck(this, BoxSlider);

  var swiperEl = container.querySelector('.swiper');
  var config = {
    loop: true,
    autoplay: {
      delay: 10000
    },
    navigation: {
      nextEl: container.querySelector('.swiper-button-next'),
      prevEl: container.querySelector('.swiper-button-prev')
    },
    pauseOnMouseEnter: true,
    slidesPerView: 1,
    spaceBetween: 20,
    breakpoints: {
      560: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 20
      }
    }
  };
  var swiper = new Swiper(swiperEl, config);
});